
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spending",
      function () {
        return require("private-next-pages/spending.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spending"])
      });
    }
  